//@ts-strict-ignore
import React from 'react';
import SVGIcon from '../SVGIcons';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const icons = {
  Favourites: 'favmodule',
  Vat: 'vatmodule',
  Nominal: 'nominalmodule',
  Diary: 'eventmodule',
  Sales: 'salesmodule',
  Suppliers: 'suppliermodule',
  Products: 'productmodule',
  Customers: 'customermodule',
  Company: 'companymodule',
  Config: 'configmodule',
  Bank: 'bankmodule',
  Purchasing: 'purchasingmodule',
  Web: 'webmodule',
  Reports: 'reportsmodule',
  System: 'configurationmodule',
};

export const getIcon: (option: string) => string = (option) => {
  return icons[option];
};

export const getMenuIcon = (menuSection, active) => {
  const fillColor = active ? p4Tokens.colorBrandMenuForeground1 : p4Tokens.colorBrandMenuForeground4;
  return (
    <div className="navmenu-icon">
      <SVGIcon icon={getIcon(menuSection)} fillColor={fillColor} height={28} width={28} />{' '}
    </div>
  );
};
